import type { ChartData } from '@/types/chart';
import { useSSEQuery } from '@/hooks/useSSEQuery';

interface ChartFiltersProps {
  chart: ChartData;
  onFilterChange?: (value: string) => void;
}

export default function ChartFilters({ chart, onFilterChange }: ChartFiltersProps) {
  const { sendQuery } = useSSEQuery();

  if (!chart.filter_options?.length) return null;

  const handleFilterChange = (filterKey: string, label: string, value: string, mode: string) => {
    if (mode === 'local') {
      onFilterChange?.(value);
    } else {
      // Remote mode: send a new query
      const instruction = `En la gráfica "${chart.title}", cambia el filtro ${label} a "${value}"`;
      sendQuery(instruction);
    }
  };

  return (
    <div className="flex gap-3 mb-4 p-3 bg-bg-primary rounded-lg border border-border-subtle">
      {chart.filter_options.map((filter) => (
        <select
          key={filter.key}
          defaultValue={filter.current_value || filter.values[0] || ''}
          onChange={(e) =>
            handleFilterChange(filter.key, filter.label, e.target.value, filter.mode)
          }
          className="bg-bg-secondary text-text-primary border border-border-strong px-3 py-1.5 rounded-md text-sm outline-none cursor-pointer hover:border-accent-blue transition-colors"
        >
          {filter.all_label && (
            <option value="">{filter.all_label}</option>
          )}
          {filter.values.map((val) => (
            <option key={val} value={val}>
              {val}
            </option>
          ))}
        </select>
      ))}
    </div>
  );
}
